import { CompanyDetails } from "_services/common.service";
import { identity } from "rxjs";


export type AuthState = {
  user: unknown | null;
  identityToken: string | null;
  companyDetails: CompanyDetails | null;
  login: (userData: unknown) => void;
  logout: () => void;
  setCompanyDetails: (details: CompanyDetails) => void;
  getCompanyDetails: () => CompanyDetails | null;
  clearCompanyDetails: () => void;
  setIdentityToken: (token: string) => void;
  getIdentityToken: () => string | null;
  clearIdentityToken: () => void;
};

export const createAuthSlice = (
  set: (state: Partial<AuthState>) => void,
  get: () => AuthState
) => ({
  user: null,
  login: (userData: unknown) => set({ user: userData }),
  logout: () => set({ user: null }),

  identityToken: null,
  setIdentityToken: (token: string) => set({ identityToken: token }),
  getIdentityToken: () => get().identityToken || identity.toString(),
  clearIdentityToken: () => set({ identityToken: null }),

  companyDetails: null,
  setCompanyDetails: (details: CompanyDetails | null) => {
    // console.log("Setting company details:", details);
    return set({ companyDetails: details });
  },
  getCompanyDetails: () => get().companyDetails,
  clearCompanyDetails: () => set({ companyDetails: null }),
})